import { WhatsAppContact } from "../../types";
import EventBus from "../event-bus";
const getContactDetailHook = new EventBus<WhatsAppContact>(
  "getContactDetailHook"
);

export default getContactDetailHook;
